import { edenTreaty } from "@elysiajs/eden";
import { AppType } from "../../../b2c-api/src/index";

type ApiClientType = ReturnType<typeof edenTreaty<AppType>>;
export const LewkAPI: ApiClientType = edenTreaty<AppType>(
  process.env.NEXT_PUBLIC_BASE_API_URL as string,
  
  {
    $fetch: {
      credentials: 'include'
    },
  }
);
